<template>
  <section>
    <button class="individual" @click="open()">
      <p>
        {{ $t("Corporate_packages") }}
      </p>
      <v-icon icon="mdi-chevron-up" v-if="style"></v-icon>

      <v-icon icon="mdi-chevron-down" v-else></v-icon>
    </button>
    <div :class="[style ? 'showing' : 'hiding']">
      <v-card
        class="mt-5 pa-5 bg-grey-lighten-4 card_subscribe"
        :class="{ 'subscribed-package': isSubscribed(int.id) }"
        v-for="(int, i) in institution"
        :key="i"
      >
        <v-card-title class="d-flex flex-sm-row flex-column justify-space-between font-weight-bold">
          <div class="d-flex align-center gap-2">
            <span>{{ int.name }}</span>
            <v-chip v-if="isSubscribed(int.id)" color="success" size="small" class="ml-2">
              <v-icon start icon="mdi-check-circle" size="16"></v-icon>
              {{ $t("Subscribed") || "مشترك" }}
            </v-chip>
          </div>
          <span>
            <span v-if="int.new_price !== undefined && int.new_price !== null" class="price-with-discount">
              <span class="original-price">{{ int.price }}</span>
              {{ int.new_price }}
            </span>
            <span v-else>{{ int.price }}</span>
            {{ $t("rs") }}
          </span>
        </v-card-title>
        <v-list class="ps-sm-16 ps-0 ms-sm-15 ms-0 bg-grey-lighten-4">
          <v-list-item v-for="(pack, i) in int.features" :key="i">
            <v-list-item-title class="font-weight-medium">
              <v-icon icon="mdi-check-circle" class="text-green"></v-icon>
              {{ pack }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <h4 class="py-2">المعلومات الاضافية للباقة</h4>
        <p class="pb-4">باقة تتيح لك عدة مزايا</p>
        <div v-if="!isSubscribed(int.id)" class="d-flex flex-sm-row flex-column">
          <v-text-field
            density="compact"
            variant="solo"
            single-line
            hide-details
            class="rounded font-weight-medium w-75 me-sm-3 me-0 input_discount"
            elevation="0"
            :placeholder="$t('Discount')"
            style="box-shadow: none"
            v-model="int.coupon"
          >
          </v-text-field>
          <button
            class="w-25 text-white mx-auto mt-sm-0 mt-2 pa-sm-0 pa-2 rounded send_code"
            style="background-color: #f6c712"
            @click="send(int, i)"
          >
            {{ $t("Send") }}
          </button>
        </div>
        <div class="text-red pt-2">{{ int.errorMessage ? int.errorMessage : "" }}</div>
        <div class="text-center">
          <button
            v-if="!isSubscribed(int.id)"
            class="w-100 pa-sm-3 pa-1 rounded mt-sm-8 mt-3"
            style="border: 3px solid #d9d9d9; font-size: 23px"
            @click="dialog = true"
          >
            {{ $t("Payment_method") }}
          </button>
          <button
            v-if="!isSubscribed(int.id)"
            class="w-75 mt-4 pa-2 rounded font-weight-bold subscribe-btn"
            style="background-color: #f6c712"
            @click="subscriptionStore(int.id)"
          >
            {{ $t("Subscribe_now") }}
          </button>
          <div v-else class="w-75 mt-4 pa-2 rounded font-weight-bold subscribed-badge">
            <v-icon icon="mdi-check-circle" class="mr-2"></v-icon>
            {{ $t("Already_Subscribed") || "أنت مشترك في هذه الباقة" }}
          </div>
        </div>

        <v-dialog width="800" v-model="dialog">
          <v-card class="form_select pa-3">
            <v-card-title class="text-center text-h5 mb-5 font-weight-bold">
              {{ $t("Payment_method") }}
            </v-card-title>
            <v-form @submit.prevent="saveselect" enctype="multipart/form-data">
              <v-checkbox
                v-model="selected"
                :label="$t('Electronic_payment')"
                value="0"
                @change="changefile()"
              ></v-checkbox>
              <v-checkbox
                v-model="selected"
                :label="$t('Bank')"
                value="1"
                @change="changefile()"
              ></v-checkbox>
              <div v-if="imagefile" 
              class=" justify-center rounded elevation-2 mb-3"
              style="display: grid;"
              >
                <input
                  ref="file"
                  accept=".pdf, image/jpeg, image/png"
                  type="file"
                  class="pa-5 w-100"
                  @change="handleFileChange"
                />
              </div>

              <v-btn
                class="w-100 elevation-0 bg-yellow-darken-2 font-weight-bold"
                type="submit"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </section>
</template>
<script>
import crudDataService from "@/Services/crudDataService";

export default {
  props: {
    userSubscriptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      style: false,
      institution: [],
      dialog: false,
      selected: null,
      selectedFile: null,
      imagefile: false,
      errorMessage: "", // For subscription errors
    };
  },
  methods: {
    isSubscribed(packageId) {
      return this.userSubscriptions.some(sub => sub.id === packageId);
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files.item(0);
    },
    changefile() {
      if (this.selected == 1) {
        this.imagefile = !this.imagefile;
      }
    },

    saveselect() {
      this.dialog = false;
    },
    open() {
      this.style = !this.style;
    },
    async send(obj, index) {
      // Clear previous error for this package
      this.institution[index].errorMessage = '';
      
      await crudDataService
        .create(`coupons/check`, {
          coupon: obj.coupon || '',
          price: obj.price,
          subscription_id: obj.id,
        })
        .then((res) => {
          console.log(res.data.data, "wdjqpowjpwd");
          // Update the new_price for this specific package
          if (res.data.data && res.data.data.new_price !== undefined) {
            this.institution[index].new_price = res.data.data.new_price;
          }
        })
        .catch((error) => {
          if (error.response) {
            // The API responded with an error message
            this.institution[index].errorMessage = error.response.data.message;
          } else if (error.request) {
            this.institution[index].errorMessage = "No response from the server";
          } else {
            this.institution[index].errorMessage = error.message;
          }
          console.error("Coupon error:", this.institution[index].errorMessage);
          // Clear new_price on error
          this.institution[index].new_price = null;
        });
    },
    async package() {
      let response = await crudDataService.getAll(`subscriptions`);
      response.data.data.forEach((element) => {
        if (element.premium == 1) {
          // Initialize coupon and errorMessage for each package
          this.institution.push({
            ...element,
            coupon: '',
            errorMessage: '',
            new_price: null
          });
        }
      });
    },
    async subscriptionStore(id) {
      let form = new FormData();
      if (this.selected == 1) {
        form.append("receipt", this.selectedFile);
      }
      // Find the package to get its coupon
      const packageData = this.institution.find(pkg => pkg.id === id);
      const couponCode = packageData?.coupon || '';
      
      form.append("subscription_id", id);
      form.append("payment_id", this.selected);
      form.append("coupon", couponCode);
      form.append("payment_method", "online");
      
      try {
        let res = await crudDataService.create(`subscription/store`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        
        // Check if URL exists in response (payment required)
        if (res.data.data?.url) {
          // Redirect to payment page
          window.location.href = res.data.data.url;
        } else {
          // No payment required (100% discount or free subscription)
          // Redirect to subscriptions page or home
          this.$router.push({ name: 'Subscriptions' });
          // Optionally reload to update subscription status
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.error('Subscription error:', error);
        this.errorMessage = error.response?.data?.message || 'حدث خطأ أثناء الاشتراك';
      }
    },
  },
  mounted() {
    this.package();
  },
};
</script>
<style lang="scss" scoped>
.card_subscribe {
  .v-text-field input.v-field__input {
    padding: 20px;
  }
}
.send_code {
  font-size: 22px;
}
.individual {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #f6c712;
  width: 100%;
  border-radius: 5px;
  padding: 15px;
  font-weight: 500;
  font-size: 22px;
}
.hiding {
  display: none;
}
.showing {
  display: block;
}

.price-with-discount {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
  
  .original-price {
    text-decoration: line-through;
    color: #9ca3af;
    font-size: 0.9em;
    font-weight: 400;
  }
}

[dir="rtl"] .price-with-discount {
  flex-direction: row-reverse;
}

/* Subscribed Package Styles */
.subscribed-package {
  border: 2px solid #10b981 !important;
  background: linear-gradient(135deg, #f0fdf4 0%, #f9fafb 100%) !important;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 40px 40px 0;
    border-color: transparent #10b981 transparent transparent;
  }
  
  &::after {
    content: '✓';
    position: absolute;
    top: 8px;
    right: 8px;
    color: white;
    font-size: 18px;
    font-weight: bold;
    z-index: 1;
  }
}

.subscribed-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 12px;
  cursor: default;
  
  .v-icon {
    color: white;
  }
}

.gap-2 {
  gap: 8px;
}
</style>
